<template>
    <div>
            <div class="vx-row my-4" v-for="(item, i) in data" :key="i + 'cf'">
                <div class="vx-col w-full">
                    <!-- Название дисциплины  -->
                    <vx-card class="px-4 vs-con-loading__container"
                             :id="`div-with-loading${item.uid}`">
                        <div class="flex flex-wrap items-center">
                        </div>
                        <div class="flex flex-wrap">
                            <vs-checkbox v-for="checkbox in item.select"
                                         v-model="selected[checkbox.uid]"
                                         class="my-2"
                                         :value="checkbox.uid"
                                         :key="checkbox.uid"
                                         @change="sendListSelected(item, checkbox.uid)"
                                         :disabled="DisabledLang||closed_data ">
                                {{ checkbox.name }}
                            </vs-checkbox>
                        </div>
                        <div class="vx-row mt-6">
                            <div class="flex">
                                <div class="mail__attachment">
                                    <vs-button :color="isCheck.color"
                                               class="px-4 py-2 mr-3 cursor-pointer"
                                               :disabled="isCheck.disabled||DisabledLang||closed_data"
                                               @click="SendDiscepline(item,item.select)">
                                        {{ isCheck.text }}
                                    </vs-button>
                                    <vs-button v-if="isCheck.cancel_text"
                                               color="primary"
                                               class="px-4 py-2 mr-3 cursor-pointer"
                                               :disabled="isCheck.disabled||closed_data"
                                               @click="СancelDiscepline(item ,item.select)">
                                        {{ isCheck.cancel_text }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </vx-card>
                </div>
            </div>
    </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {mapGetters, mapMutations} from "vuex";
export default {
    props: {
        data: {
            required: true,
            type: Array,
        },
        acadFilter: {
            required: false,
            type: Boolean,
        },
        isCheck:{
            type:Object
        },
        DisabledLang:{
            type:Boolean,
            required: false,
        },
        status:{
            type:Object
        }

    },
    computed: {
        ...mapGetters({
            itocline: 'regis_discepline/getitocline'
        }),
    },
    components: {
        VuePerfectScrollbar,
    },
    data() {
        return {
            showThread: false,
            settings: {
                maxScrollbarLength: 80,
                wheelSpeed: 1,
            },
            selectLang: null,
            selectTeacher: null,
            teacherItems: [],
            statusIcons: [
                "AlertCircleIcon",
                "CheckSquareIcon",
                "XCircleIcon",
                "CheckCircleIcon",
                "EditIcon",
            ],
            statusColor: [
                "color: orange",
                "color: #0000ff",
                "color: red",
                "color: green",
                "color: #8000ff",
            ],
            selected: [],
            closed_data:false
        };
    },
    watch: {
        async data() {
            this.updateSelectCheckbox();
            await this.$http.get(
                `/organizations/uid_get_discipline_credit/`+this.data[0].discipline_credit+`/`,
            ).then((res)=>{this.closed_data = res.data.closedt})
        },
    },
    async created() {
        if (this.itocline){
            this.updateSelectCheckbox();
        }
    },

    methods: {
        async request_backend(item){
            if (this.itocline){
                await this.$http.put(
                    `user/control_forms/${ item.discipline_credit }/choose/`,
                    { chosen_control_forms: item.chosen_control_forms }
                );
            }
        },
        async SendDiscepline(item,select){
            var start_length = item.chosen_control_forms
            select.forEach((i)=>{
                start_length = start_length.filter(
                    (c) => c !== i.uid
                );
            })
            if (item.chosen_control_forms.length>=start_length.length+1){
                if(this.status.nevybran||this.status.neizuchaetsja){

                    this.$emit('SendDiscepline',item)
                    // this.request_backend(item)

                }else{
                    this.request_backend(item)
                    this.$vs.notify({
                        text:this.$t('succesful') ,
                        color: 'success'
                    })
                }
            }else{
                this.$vs.notify({
                    text: 'Выберите форму контроля',
                    color: 'warning'
                })
            }
        },
        async СancelDiscepline(item,select){
            select.forEach((i)=>{
                item.chosen_control_forms = item.chosen_control_forms.filter(
                    (c) => c !== i.uid
                );
            })
            await this.$http.put(
                `user/control_forms/${ item.discipline_credit }/choose/`,
                { chosen_control_forms: item.chosen_control_forms }
            ).then(this.selected=[],this.$emit('СancelDiscepline'));

        },
        updateSelectCheckbox() {
            this.data.forEach((item) => {
                item.chosen_control_forms.forEach((c) => {
                    this.selected[c] = true;
                });
            });
        },
        // При нажатии на checkbox
        async sendListSelected(item, uid) {
            if (this.selected[uid] === true) {
                item.chosen_control_forms.push(uid);
            } else {
                item.chosen_control_forms = item.chosen_control_forms.filter(
                    (c) => c !== uid
                );
            }
        },
    },


};
</script>

 <style lang="scss" scoped>
.todo__filters-container {
    .multiselect__single {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
.full-vs-sidebar .vs-sidebar {
    max-width: 100%;
}

.scroll-area-emcfull-content {
    position: relative;
    width: 100%;
    height: calc(100% - 85px);
    .archive_link {
        color: #ffffff !important;
    }
}
@media only screen and (max-width: 900px) {
    .scroll-area-emcfull-content {
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }
}
</style>
